exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SelectionToolHelper-6426ed08 .controls-ca0fa372{background-color:#eee;color:#757575;padding:1em;padding-left:.5em;text-align:left;font-size:14px;cursor:pointer}.SelectionToolHelper-6426ed08 .header-2603e1a8{background-color:#6982FF;color:#FAFAFA;padding:1em;text-align:center;font-size:16px}.SelectionToolHelper-6426ed08 .helpText-bf3f4d56{padding:1em}.swatches-4a60019b{width:60px;margin:10px;display:flex}.swatch-40ef3b92{padding:4px;border-radius:4px;border:1px solid white}.swatch-40ef3b92.selected-0070cbcc{border:1px solid #EA6D2C}.swatch-40ef3b92>div{cursor:pointer;border-radius:2px;width:20px;height:20px}\n", ""]);

// Exports
exports.locals = {
	"SelectionToolHelper": "SelectionToolHelper-6426ed08",
	"controls": "controls-ca0fa372",
	"header": "header-2603e1a8",
	"helpText": "helpText-bf3f4d56",
	"swatches": "swatches-4a60019b",
	"swatch": "swatch-40ef3b92",
	"selected": "selected-0070cbcc"
};